import { Checkbox } from "@/components/ui/checkbox";
import { Camera } from "@phosphor-icons/react";

export function MemorySelector({ chapters, selected, onToggle, onSetMany }) {
  const all = chapters.flatMap((c) => c.memories.map((m) => m.id));
  return (
    <div data-testid="memory-selector" className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <span data-testid="memory-selected-count" className="text-sm text-[#4A4540]">
          {selected.size} of {all.length} memories selected
        </span>
        <button type="button" data-testid="select-all-memories" onClick={() => onSetMany(all, true)} className="rounded-full border border-[#4A4540]/20 px-3 py-1 text-xs font-medium text-[#4A4540] hover:border-[#E07A5A]">Select all</button>
        <button type="button" data-testid="clear-all-memories" onClick={() => onSetMany(all, false)} className="rounded-full border border-[#4A4540]/20 px-3 py-1 text-xs font-medium text-[#4A4540] hover:border-[#E07A5A]">Clear</button>
      </div>
      {chapters.map((c) => {
        const ids = c.memories.map((m) => m.id);
        const allOn = ids.every((id) => selected.has(id));
        return (
          <div key={c.season} data-testid={`season-group-${c.season}`} className="rounded-xl border border-[#4A4540]/10 bg-white p-3">
            <label className="flex cursor-pointer items-center gap-2">
              <Checkbox data-testid={`season-toggle-${c.season}`} checked={allOn} onCheckedChange={(v) => onSetMany(ids, !!v)} />
              <span className="text-sm font-semibold text-[#A84A32]">{c.season}</span>
              <span className="text-xs text-[#8A7F76]">· {c.count} {c.count === 1 ? "memory" : "memories"}</span>
            </label>
            <div className="mt-2 space-y-1.5 pl-6">
              {c.memories.map((m) => (
                <label key={m.id} className="flex cursor-pointer items-start gap-2">
                  <Checkbox data-testid={`memory-toggle-${m.id}`} checked={selected.has(m.id)} onCheckedChange={() => onToggle(m.id)} className="mt-0.5" />
                  <span className="text-sm text-[#2C2A28]">
                    {m.title}{m.date ? <span className="text-xs text-[#8A7F76]"> · {m.date}</span> : null}
                    {m.photo_reminder && (
                      <span data-testid={`photo-reminder-${m.id}`} className="mt-0.5 flex items-center gap-1 text-xs italic text-[#8A5A2B]">
                        <Camera size={12} /> Photo reminder: {m.photo_reminder}
                      </span>
                    )}
                  </span>
                </label>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
